import React, { useEffect } from "react";
import { Box, CircularProgress, Divider, Typography } from "@mui/material";
import { useCommentsAndLogs } from "../hooks/useCommentsAndLogs";
import { formatDate } from "../utils/formatDate";

interface LogProps {
    topic: string[];
    sub_event: string[];
    object_id: string | undefined;
    parent_id: string | undefined;
    variant?: 'activity' | 'logs';
};

export const Log: React.FC<LogProps> = ({ topic, sub_event, object_id, parent_id, variant }) => {

    const { isLogsPending, logs, getLogs } = useCommentsAndLogs({ topic, sub_event, object_id, parent_id });

    useEffect(() => {
        getLogs();
    }, []);

    if (isLogsPending) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <CircularProgress />
            </Box>
        )
    };

    return (
        <Box display={'flex'} flexDirection={'column'} height={'100%'} gap={2} sx={{ overflowY: 'auto', pr: 2 }}>
            {
                logs.length === 0 ?
                    <Typography variant="body2" color="text.secondary" textAlign="center" mt={5}>
                        No logs found
                    </Typography>
                    :
                    variant === 'activity' ?
                        logs.map((value: any, index: React.Key | null | undefined) => (
                            <Box key={index} display={'flex'} flexDirection={'column'} gap={.1} bgcolor={'action.hover'} width={'100%'} p={1.5} borderRadius={1}>
                                <Typography variant="caption" color="text.secondary">
                                    {value.topic}
                                </Typography>
                                <Typography variant="caption" color="text.primary">
                                    {value.event} - {value.details}
                                </Typography>
                                <Divider sx={{ my: .5 }} />
                                <Typography variant="caption" color="text.primary">
                                    {value.user_name} - {formatDate(value.created_date)}
                                </Typography>
                            </Box>
                        ))
                        :
                        logs.map((value: { user_name: string; created_date: string; details: string; }, index: React.Key | null | undefined) => (
                            <Box key={index} display={'flex'} alignItems={'start'} justifyContent={'start'} flexDirection={'column'} bgcolor={'action.hover'} width={'100%'} p={1.5} borderRadius={1}>
                                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
                                    <Typography variant="caption" color="text.primary">
                                        {value.user_name}
                                    </Typography>
                                    <Typography variant="caption" color="text.primary">
                                        {formatDate(value.created_date)}
                                    </Typography>
                                </Box>
                                <Typography variant="caption" color="text.secondary">
                                    {value.details}
                                </Typography>
                            </Box>
                        ))
            }
        </Box>
    )
}